<div class="batch-document-toast" role="alert" (click)="dismissToast()">
  <div class="batch-document-toast__content">
    <p class="batch-document-toast__title">{{ payload.title }}</p>
    <p class="batch-document-toast__subtitle">{{ payload.subtitle }}</p>
  </div>
  @if (payload.showDownload) {
    <button
      type="button"
      class="batch-document-toast__action"
      [disabled]="isDownloading()"
      (click)="download($event)"
    >
      {{ downloadLabel }}
    </button>
  }
</div>
